import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import { motion } from 'framer-motion';
import { useTheme } from '@emotion/react';

export default function PerformanceMetricsChart({ data }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      className={`rounded-2xl shadow-xl p-6 transition-colors duration-300 ${isDark ? 'bg-gray-900' : 'bg-white'}`}
    >
      <div className="flex justify-between items-center mb-2">
        <h2 className={`text-xl font-bold ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>Performance Metrics</h2>
        <span className="text-gray-400 text-sm">Success rate & satisfaction</span>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke={isDark ? "#374151" : "#e5e7eb"} />
          <XAxis dataKey="day" stroke={isDark ? "#d1d5db" : "#374151"} />
          <YAxis stroke={isDark ? "#d1d5db" : "#374151"} />
          <Tooltip contentStyle={{ borderRadius: 12, boxShadow: '0 2px 8px #0001', background: isDark ? "#1f2937" : "#fff", color: isDark ? "#fff" : "#000" }} />
          <Legend wrapperStyle={{ color: isDark ? '#fff' : '#000' }} />
          <Line
            type="monotone"
            dataKey="successRate"
            name="Success Rate (%)"
            stroke={isDark ? "#34D399" : "#10B981"}
            strokeWidth={3}
            dot={{ r: 6 }}
            activeDot={{ r: 10 }}
            isAnimationActive={true}
            animationDuration={1200}
          />
          <Line
            type="monotone"
            dataKey="satisfaction"
            name="Satisfaction (1-5)"
            stroke={isDark ? "#FBBF24" : "#F59E42"}
            strokeWidth={3}
            dot={{ r: 6 }}
            activeDot={{ r: 10 }}
            isAnimationActive={true}
            animationDuration={1200}
          />
        </LineChart>
      </ResponsiveContainer>
    </motion.div>
  );
} 